import React from "react";
import { Trans } from "@lingui/macro";
import PropTypes from "kf-proptypes/widgets";

import { UserIcon, AVATAR_SIZE } from "../usericon/index.jsx";

import styles from "./usericonlist.css";

export const USER_ICON_LIST_SIZE = {
  TINY: "tiny"
};

UserIconList.propTypes = {
  /**
   * Users details to display the icon
   */
  users: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      Name: PropTypes.string.isRequired,
      Kind: PropTypes.string.isRequired,
      Permissions: PropTypes.arrayOf(PropTypes.string),
      Roles: PropTypes.string
    })
  ).isRequired,
  /**
   * how much icon should display
   */
  count: PropTypes.number,
  /**
   * size of the user icon
   */
  size: PropTypes.oneOf(USER_ICON_LIST_SIZE.TINY)
};

/**
 * Display the user icon list.
 */

export function UserIconList(props) {
  const { count, users = [], size } = props;

  switch (size) {
    case USER_ICON_LIST_SIZE.TINY:
      return (
        <div className={` ${styles.userIconTiny}`}>
          <ul>
            {users
              .reverse()
              .slice(0, 3)
              .map((userDetails, index) => {
                return (
                  <li key={index}>
                    <UserIcon
                      size={AVATAR_SIZE.SIZE24}
                      userId={userDetails._id}
                      name={userDetails.Name}
                    />
                  </li>
                );
              })}
          </ul>
          {count - 3 > 0 && (
            <div className={`${styles.count} micro-400`}>
              <span>+{count - 3}</span>
            </div>
          )}
        </div>
      );
    default:
      return (
        <div className={styles.usericonlist}>
          <ul>
            {users
              .reverse()
              .slice(0, 3)
              .map((userDetails, index) => {
                return (
                  <li key={index}>
                    <UserIcon
                      className={styles.usericon}
                      size={AVATAR_SIZE.SIZE20}
                      userId={userDetails._id}
                      name={userDetails.Name}
                    />
                  </li>
                );
              })}
          </ul>
          {count && (
            <span className={styles.hinttext}>
              {count} <Trans>member(s)</Trans>
            </span>
          )}
        </div>
      );
  }
}

UserIconList.defaultProps = {
  users: []
};
